export const ProjectStatus = {
  PRIVATE: "PRIVATE",
  SHARED: "SHARED",
  PUBLIC: "PUBLIC",
};

export type Status = keyof typeof ProjectStatus;

export const toStatus = (s?: string | null): Status => {
  const up = (s ?? "PRIVATE").toUpperCase();
  return (
    up === "PUBLIC" || up === "SHARED" || up === "PRIVATE" ? up : "PRIVATE"
  ) as Status;
};

export type Coordinate = { x: number; y: number; z: number };

export type Pole = {
  identifier: string;
  position: Coordinate;
  direction: Coordinate;
  length: number;
};

export type SquareLashing = {
  identifier: string;
  fixedPoleIdentifier: string;
  loosePoleIdentifier: string;
};

export type BipodLashing = {
  identifier: string;
  pole1Identifier: string;
  pole2Identifier: string;
};

export type TripodLashing = {
  identifier: string;
  leftPoleIdentifier: string;
  middlePoleIdentifier: string;
  rightPoleIdentifier: string;
};

export type ScaffoldLashing = {
  identifier: string;
  pole1Identifier: string;
  pole2Identifier: string;
  offset: number;
};

export type ProjectMeta = {
  id: string;
  description: string;
  name: string;
  status: Status;
  createdAt: string;
  owner: ExposedUser | null;
  poleset: Poleset | null;
};

export type ExposedUser = {
  id: string;
  firstName: string;
  lastName: string;
};

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  darkmode: boolean;
  language: string;
  isAdmin: boolean;
};

export type PoleType = {
  id: string;
  length: number;
  color: string;
  radius: number;
};

export type Poleset = {
  id: string;
  name: string;
  poles: PoleType[];
};
